<template>
  <section class="sec_invited_buckingham">
    <div class="big_container">
      <div class="main_contenet">
        <h2 class="sec_heading" v-html="shopifyData.secHeading" />
        <h4 class="card_heading_b" v-html="shopifyData.secSubHeading" />
        <p class="body_text" v-html="shopifyData.secInfo" />
      </div>
      <div class="sec_content">
        <div class="sec_video">
          <div v-if="shopifyData.collage_data[0]" class="sec-image-modifier">
            <img
              v-lazy="shopifyData.collage_data[0].imgUrl.src"
              class="item1"
              :src-placeholder="shopifyData.collage_data[0].imgUrl.placeholder"
              :alt="shopifyData.collage_data[0].imgUrl.alt || 'Invited Buckingham Image'"
              loading="lazy"
              aria-hidden="true"
              aria-label="Invited Buckingham Image"
              width=""
              height=""
            />
            <p class="fig_caption" v-html="shopifyData.collage_data[0].imageInfo" />
          </div>
          <template v-if="shopifyData.checkImage === 'true'">
            <video
              autoplay="true"
              loop="true"
              muted="true"
              controlsList="nodownload"
              disablepictureinpicture
              webkit-playsinline="true"
              playsinline="true"
              preload="none"
            >
              <source v-lazy="shopifyData.videolink" />
            </video>
          </template>
          <template v-else>
            <img
              v-lazy="shopifyData.imgUrl.src"
              class="grid_img"
              :src-placeholder="shopifyData.imgUrl.placeholder"
              :alt="shopifyData.imgUrl.alt || 'Invited Buckingham Image'"
              loading="lazy"
              aria-hidden="true"
              aria-label="Invited Buckingham Image"
              width=""
              height=""
            />
          </template>
        </div>
        <div class="sec_img">
          <div class="t-start">
            <div v-if="shopifyData.collage_data[1]" class="img_item1">
              <img
                v-lazy="shopifyData.collage_data[1].imgUrl.src"
                :src-placeholder="shopifyData.collage_data[1].imgUrl.placeholder"
                :alt="shopifyData.collage_data[1].imgUrl.alt || 'Invited Buckingham Image'"
                loading="lazy"
                aria-hidden="true"
                aria-label="Invited Buckingham Image"
                width=""
                height=""
              />
              <p class="fig_caption" v-html="shopifyData.collage_data[1].imageInfo" />
            </div>
          </div>
          <div class="t-end">
            <div v-if="shopifyData.collage_data[2]" class="item1 img_item2">
              <img
                v-lazy="shopifyData.collage_data[2].imgUrl.src"
                :src-placeholder="shopifyData.collage_data[2].imgUrl.placeholder"
                :alt="shopifyData.collage_data[2].imgUrl.alt || 'Invited Buckingham Image'"
                loading="lazy"
                aria-hidden="true"
                aria-label="Invited Buckingham Image"
                width=""
                height=""
              />
              <p class="fig_caption" v-html="shopifyData.collage_data[2].imageInfo" />
            </div>
          </div>
          <div class="t-center">
            <div v-if="shopifyData.collage_data[3]" class="img_item3">
              <img
                v-lazy="shopifyData.collage_data[3].imgUrl.src"
                :src-placeholder="shopifyData.collage_data[3].imgUrl.placeholder"
                :alt="shopifyData.collage_data[3].imgUrl.alt || 'Invited Buckingham Image'"
                loading="lazy"
                aria-hidden="true"
                aria-label="Invited Buckingham Image"
                width=""
                height=""
              />
              <p class="fig_caption" v-html="shopifyData.collage_data[3].imageInfo" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.sec_invited_buckingham {
  padding: 125px 0 46px;
}

.sec_heading {
  line-height: 44px;
}

.main_contenet {
  max-width: 665px;
  margin: 0 auto;
  width: 100%;
}

.sec_content {
  display: grid;
  grid-template-columns: 28% 64%;
  align-items: center;
  margin: 34px auto 0;
  gap: 30px;
  justify-content: center;
  max-width: 1440px;
}

.card_heading_b {
  margin: 14px 0;
  text-transform: initial;
}
.body_text {
  line-height: 19px;
}
.sec_video {
  max-width: 300px;
  width: 100%;
}
.img_item1 {
  max-width: 540px;
  width: 100%;
  height: auto;
}
.img_item2 {
  max-width: 490px;
  width: 100%;
  height: auto;
}
.item1 {
  margin: 70px 0 0px auto;
  width: fit-content;
  text-align: start;
}
.img_item3 {
  max-width: 330px;
  width: 100%;
  height: auto;
  margin: 100px auto 0;
}

.fig_caption {
  text-align: start;
}
.sec-image-modifier {
  margin-bottom: 30px;
}
/* Responsive Css Code */
@media screen and (max-width: 991px) {
  .sec_video video {
    width: 100%;
  }

  .big_container {
    padding: 0 5px;
  }
  .main_contenet {
    padding: 0 9px;
  }
  .sec_invited_buckingham {
    padding: 80px 0 100px;
  }
}

@media screen and (max-width: 991px) {
  .sec_invited_buckingham {
    padding: 58px 0 152px;
  }
  .sec_content {
    margin-top: 43px;
  }

  .fig_caption {
    font-size: 10px !important;
  }
}
@media screen and (max-width: 575px) {
  .img_item1 {
    max-width: 160px;
  }

  .img_item2 {
    max-width: 176px;
    margin: 25px 0 30px auto;
  }

  .img_item3 {
    max-width: 117px;
    margin: 0 0 0 35px;
  }

  .sec_video video,
  .sec_video img {
    width: 90px;
  }
}
</style>
